// extracted by mini-css-extract-plugin
export default {"creationType":"CreationType_creationType__Xy5gu","radioLabel":"CreationType_radioLabel__JmWiX"};